import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

export interface User {
  id: string
  email: string
  name?: string
  companyIds: string[]
  companyRoles?: Record<string, string[]>
  isSuperAdmin?: boolean
  companyLanguage?: 'es' | 'en'
}

interface AuthState {
  isLogged: boolean
  message: string
  user?: User
  login: (user: User) => void
  logout: (message?: string) => void
  isManagerAdmin: (companyId?: string) => boolean
}

export const useAuthStore = create<AuthState>()(
  immer(
    devtools((set, get) => ({
      isLogged: false,
      message: '',
      user: undefined,
      login: (user: User) => set({ isLogged: true, user }),
      logout: (message?: string) => set({ isLogged: false, message: message ?? '', user: undefined }),
      isManagerAdmin: (companyId?: string) => {
        const user = get().user
        if (!user?.companyRoles) return false
        const targetCompanyId = companyId ?? user.companyIds?.[0]
        if (!targetCompanyId) return false
        const roles = user.companyRoles[targetCompanyId] ?? []
        return roles.includes('manager_admin')
      },
    })),
  ),
)
